import './instrument';
import { StrictMode } from 'react';
import { RouterProvider } from 'react-router/dom';
import * as ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { ConvexProviderWithAuth, ConvexReactClient } from 'convex/react';
import { PageErrorBoundary } from './components/page-error-boundary';
import { useConvexAuthFromClerk } from './hooks/use-app-auth';
import { router } from './app';
import { initAnalytics } from '@/lib/analytics/analytics';
import { initI18n } from './i18n/config';
import { startVersionCheck } from '@/lib/deploy-skew/version-check';
import { RUNTIME_CONFIG } from '@/lib/runtime/runtime-config';
import './styles.css';

initAnalytics();
startVersionCheck();

// Which Clerk instance and Convex deployment this bundle uses depends on the
// build mode — see lib/runtime/runtime-config.ts.
const {
  clerkPublishableKey: CLERK_PUBLISHABLE_KEY,
  convexUrl: CONVEX_URL,
  error: CONFIG_ERROR,
} = RUNTIME_CONFIG;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

function render() {
  if (CLERK_PUBLISHABLE_KEY && CONVEX_URL) {
    const convex = new ConvexReactClient(CONVEX_URL);

    root.render(
      <StrictMode>
        <PageErrorBoundary variant="standalone">
          <ClerkProvider
            publishableKey={CLERK_PUBLISHABLE_KEY}
            signInUrl="/sign-in"
            signUpUrl="/sign-up"
            afterSignOutUrl="/"
          >
            {/* ConvexProviderWithClerk, plus the e2e token override — see
                hooks/use-app-auth.ts. ClerkProvider stays mounted either way: the
                sign-in/sign-up pages and <UserButton /> still need it. */}
            <ConvexProviderWithAuth
              client={convex}
              useAuth={useConvexAuthFromClerk}
            >
              <RouterProvider router={router} />
            </ConvexProviderWithAuth>
          </ClerkProvider>
        </PageErrorBoundary>
      </StrictMode>,
    );
  } else {
    console.error(
      CONFIG_ERROR ??
        'Missing VITE_CLERK_PUBLISHABLE_KEY or VITE_CONVEX_URL — running without auth providers.',
    );

    root.render(
      <StrictMode>
        <PageErrorBoundary variant="standalone">
          <RouterProvider router={router} />
        </PageErrorBoundary>
      </StrictMode>,
    );
  }
}

// Locale bundles are code-split per language: wait for the active one before
// the first render so no component paints raw translation keys.
initI18n().then(render);
